// @flow

import { toLowerCaseString } from 'app/common/CommonUtils';

export default (needle: string, haystack: string) => {
  // returns a score, 0 being no match, 100 being perfect

  needle = toLowerCaseString(needle);
  haystack = toLowerCaseString(haystack);

  if (haystack === needle) {
    return 100;
  }

  let score = 0;
  if (haystack.indexOf(needle) >= 0) {
    score += 50;
  }

  return score;
};
